// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as TrashBDefault } from '../../../../../ui-v3/src/assets/icons/default/general/trash-b.svg?react';
import { ReactComponent as TrashBSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/TRASH-B.svg?react';
import { createIcons } from '../../Icon';
const TrashBIcon = /* @__PURE__ */ createIcons('TrashB', {
    default: TrashBDefault,
    solid: TrashBSolid
});
TrashBIcon.supportedTypes = [
    'default',
    'solid'
];
TrashBIcon.category = 'general';
export default TrashBIcon;
